<div #beforeContent>
  <ng-content select="[before-content]"></ng-content>
</div>

@if (text && !beforeContent.children.length) {
  <div class="no-leading font-bold w-7 text-size_xs" [ngClass]="[textColor ? textColor : 'text-navy-700']">
    {{ text }}
  </div>
}

<div
  [appTooltip]="hasTooltip() ? tooltipContent : null"
  [tooltipPosition]="tooltipPosition"
  class="progress-bar"
  [class]="heightClass"
>
  <div
    [ngClass]="{
      'allow-bg-color-change': allowBgColorChange,
      done: percent() === completePercentage && !isNegative,
      overflow: percent() > completePercentage && !isNegative,
      underflow: isNegative,
    }"
    [class]="fillClass"
    [ngStyle]="{
      width: width() + '%',
    }"
    class="fill"
  ></div>
  <div class="secondary-fill" [class]="secondaryFillClass" [ngStyle]="{ width: secondaryWidth() + '%' }"></div>
</div>

<div class="contents" #afterContent>
  <ng-content select="[after-content]"></ng-content>
</div>

@if (!afterContent.children.length) {
  <div
    [ngClass]="{
      'min-w-6': percentWidth === 'default',
      'min-w-11': percentWidth === 'big',
      '!text-red-600': percentDisplay() > completePercentage,
      negative: percentDisplay() < 0,
      'text-[12px]': biggerPercentText,
      'text-[8px]': !biggerPercentText,
    }"
    class="no-leading font-bold text-navy-700 flex gap-0"
  >
    {{ Math.abs(Math.floor(percentDisplay()) ?? 0) }}%
  </div>
}

<ng-template #tooltipContent>
  <ng-content select="[tooltip-content]"></ng-content>
</ng-template>
